/** The atom does not exist: the server answered the subscription with "does not exist". */
export class AtomNotFoundError extends Error {
  public readonly atomName: string;
  constructor(message: string, atomName: string) {
    super(message);
    this.name = "AtomNotFoundError";
    this.atomName = atomName;
  }
}
